import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';

const TermsAndConditions = ({ show, onHide, isPage = false }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (isPage) {
      navigate(-1);
    } else {
      onHide();
    }
  };

  const content = (
    <>
      <div className="text-center mb-4">
        <h4 className="text-warning">Taxi-Local.uk Ltd</h4>
        <p className="text-muted">Terms and Conditions of Service</p>
      </div>
      
      <div className="mb-4">
        <p className="text-muted small">
          <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-GB')}
        </p>
      </div>
      
      <div className="mb-4">
        <h5>1. Introduction</h5>
        <p>
          These Terms and Conditions govern your use of the Taxi-Local.uk platform operated by Taxi-Local.uk Ltd. 
          By accessing or using our service, you agree to be bound by these terms.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>2. Service Description</h5>
        <p>
          Taxi-Local.uk is a platform that connects professional taxi drivers with customers seeking 
          transportation services. We provide job management, scheduling, and payment processing tools 
          for registered drivers and booking services for customers.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>3. Driver Registration and Requirements</h5>
        <ul>
          <li>All drivers must hold valid UK taxi licenses and insurance</li>
          <li>Vehicles must meet local authority standards and requirements</li>
          <li>Drivers must maintain professional conduct and appearance</li>
          <li>All necessary documentation must be kept current and valid</li>
        </ul>
      </div>
      
      <div className="mb-4">
        <h5>4. Customer Responsibilities</h5>
        <ul>
          <li>Provide accurate pickup and destination information</li>
          <li>Be ready at the agreed pickup time</li>
          <li>Treat drivers and vehicles with respect</li>
          <li>Pay agreed fares promptly and in full</li>
        </ul>
      </div>
      
      <div className="mb-4">
        <h5>5. Payment Terms</h5>
        <p>
          Payment methods include cash, card, bank transfer, and invoiced services. 
          All fares are calculated based on distance, time, and any additional services. 
          Prices are subject to change with appropriate notice.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>6. Cancellation Policy</h5>
        <p>
          Cancellations must be made with reasonable notice. Late cancellations may incur charges. 
          Drivers reserve the right to refuse service in cases of safety concerns or inappropriate behavior.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>7. Liability and Insurance</h5>
        <p>
          Taxi-Local.uk Ltd acts as an intermediary platform. Individual drivers are responsible for 
          their own insurance and compliance with local regulations. We are not liable for incidents 
          occurring during transportation.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>8. Privacy and Data Protection</h5>
        <p>
          We are committed to protecting your privacy and personal data in accordance with UK data 
          protection laws. Personal information is collected and processed only for service provision 
          and legal compliance. For more information, please see our{' '}
          <Link to="/privacy-policy" className="text-decoration-none">Privacy Policy</Link>.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>9. Service Availability</h5>
        <p>
          While we strive for 24/7 service availability, we cannot guarantee uninterrupted access 
          due to technical issues, maintenance, or circumstances beyond our control.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>10. Termination</h5>
        <p>
          We reserve the right to terminate or suspend accounts for violations of these terms, 
          fraudulent activity, or other misconduct. Users may terminate their accounts at any time.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>11. Changes to Terms</h5>
        <p>
          These terms may be updated periodically. Continued use of the service constitutes 
          acceptance of any changes. Users will be notified of significant changes.
        </p>
      </div>
      
      <div className="mb-4">
        <h5>12. Contact Information</h5>
        <p>
          For questions about these terms or our services, please contact:<br/>
          <strong>Taxi-Local.uk Ltd</strong><br/>
          Email: support@taxi-local.com<br/>
          Website: www.taxi-local.uk
        </p>
      </div>
      
      <div className="text-muted small">
        <p>These terms are governed by English law and subject to the jurisdiction of English courts.</p>
      </div>
    </>
  );

  if (isPage) {
    return (
      <div className="container mt-4 mb-5">
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="card">
              <div className="card-header bg-warning">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">📋 Terms & Conditions</h3>
                  <Button variant="outline-dark" onClick={handleClose}>
                    ← Back
                  </Button>
                </div>
              </div>
              <div className="card-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                {content}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>📋 Terms & Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {content}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAndConditions;
